const NAME_REGEX = /^[a-zA-Z_가-힣]{2,30}$/
const PHONE_BEFORE_REGEX = /01[16789]-?[^0][0-9]{2}-?[0-9]{4}/
const PHONE_LATEST_REGEX = /^010-?\d{4}-?\d{4}$/

export const VALIDATE_KEY = {
  NAME: 'name',
  PHONE_NUMBER: 'phoneNumber',
} as const

export const VALIDATE_ERROR_MESSAGE: Record<string, string> = {
  [VALIDATE_KEY.NAME]: '이름은 표준 한글 또는 영문만 입력 가능합니다',
  [VALIDATE_KEY.PHONE_NUMBER]: '휴대폰번호 형식이 올바르지 않습니다',
}

export function validateNameString(name: string): boolean {
  if (!NAME_REGEX.test(name)) return false
  const hasKorean = /[가-힣]/.test(name)
  const hasEnglish = /[a-zA-Z]/.test(name)
  return !(hasKorean && hasEnglish)
}

export function validatePhone(value: string): boolean {
  return PHONE_BEFORE_REGEX.test(value) || PHONE_LATEST_REGEX.test(value)
}

export function formatPhoneNumberMasking(target: string): string {
  return target.replace(/(\d{3})-(\d{4})-(\d{3,4})/, '$1-****-$3')
}

const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'utm_path'] as const

const UTM_CAMEL_MAP = {
  utm_source: 'utmSource',
  utm_medium: 'utmMedium',
  utm_campaign: 'utmCampaign',
  utm_term: 'utmTerm',
  utm_content: 'utmContent',
  utm_path: 'utmPath',
} as const

/**
 * URL 쿼리스트링의 utm_* 를 sessionStorage 에 저장.
 * 광고에서 진입한 첫 페이지에서 한 번 호출되면 그 세션 내내 폼 제출 body 로 전달됨.
 * 호스트가 자체 UTM 미들웨어를 안 두어도 SDK 가 자동 캡처.
 */
export function captureUtmFromUrl(): void {
  if (typeof window === 'undefined' || typeof sessionStorage === 'undefined') return
  const search = window.location?.search
  if (!search) return
  const params = new URLSearchParams(search)
  for (const key of UTM_KEYS) {
    const value = params.get(key)
    if (value) sessionStorage.setItem(key, value)
  }
}

export function getUtmParams(): Record<string, string> {
  if (typeof sessionStorage === 'undefined') return {}
  const params: Record<string, string> = {}
  for (const key of UTM_KEYS) {
    const value = sessionStorage.getItem(key)
    if (value) params[UTM_CAMEL_MAP[key]] = value
  }
  return params
}

export function isBsaNaver(): boolean {
  if (typeof sessionStorage === 'undefined') return false
  const campaign = sessionStorage.getItem('utm_campaign')
  return campaign === 'bsa_naver_pc' || campaign === 'bsa_naver_mo'
}
